import getEffectProperty from "./getEffectProperty";

const getEffectColorsByOrg = (effect: string, organization: string): any => {
  switch (organization) {
    case "Comcast":
      return {
        fill_color: effect === "Outline" ? "" : "#1d1d1b"
      };
    case "Merck":
    case "MSD":
      return {
        fill_color: effect === "Outline" ? "" : "#FFFFFF",
        [getEffectProperty(effect)]: "#00857C"
      };
    case "Intellia Therapeutics":
      return {
        fill_color: effect === "Outline" ? "" : "#D3461E"
      };
    case "Microsoft":
      return {
        fill_color: effect === "Outline" ? "" : "#FFFFFF"
      };
    case "Premise Health":
    case "Synopsys":
    case "Synopsys Private Workspace":
      return {
        fill_color: "#FFFFFF",
        [getEffectProperty(effect)]: "#5A2A82"
      };
    default:
      return {};
  }
};

export default getEffectColorsByOrg;
